import { omit } from "lodash";
import { getIsValueEmpty } from "@circle-react-shared/MemberFilters/getIsValueEmpty";

export const removeEmptyValues = (filterRules = {}) => {
  const { rules = [] } = filterRules;
  return rules
    .filter(rule => !getIsValueEmpty(rule))
    .map(rule => omit(rule, ["isInitialOpen"]));
};
